/**
 * Asynchronously loads the component for HomePage
 */
import { lazyRoute } from 'components/LazyRoute'

export default lazyRoute(() => import('./homePageContainer'))
